var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"footer__two"},[_c('div',{staticClass:"container"},[_c('div',[_vm._v(" © "+_vm._s(new Date().getFullYear())+" — Developed with ❤️ by "),_c('a',{attrs:{"href":_vm.account,"target":"_blank"}},[_vm._v("Mohamed Mahmoud")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }